<template>
    <div
        class="mb-3 mb-lg-0"
        :class="{ 'card' : !isOnlyContent, 'isOnlyContentWrapper' : isOnlyContent }">
        <div
            class="card-header"
            :class="{ 'd-none' : isOnlyContent }">
            <div class="d-flex align-items-center justify-content-between">
                <div class="font-weight-bold">添付画像</div>
                <b-button
                    @click="isShow = true"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : isShow }">
                    開く
                </b-button>
                <b-button
                    @click="isShow = false"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : ! isShow }">
                    閉じる
                </b-button>
            </div>
        </div>

        <div
            class="mt-2"
            :class="{ 'card-body' : !isOnlyContent, 'd-none' : !isOnlyContent && !isShow }">
            <div v-if="images" class="row">
                <div v-for="image in images"
                     class="col-sm-6 col-md-4 col-lg-4 mb-3 text-center">
                    <template v-if="image.url.slice(-4) === '.pdf'">
                        <div class="c-image c-image--label">
                            <div class="c-image__inner">
                                <b-img
                                    src="/images/common/icon_pdf.svg"
                                    class="attachedPdf">
                                </b-img>
                                <span
                                    v-if="image.flg_shared"
                                    class="attachedPdfFlgShared">
                                    共有済
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="c-image c-image--label">
                            <div class="c-image__inner">
                                <img
                                    :src="image.presigned_url"
                                    @click="openModal(image.presigned_url)">
                                <span v-if="image.flg_shared">共有済</span>
                            </div>
                        </div>
                    </template>

                    <div class="d-flex justify-content-center">
                        <div v-if="Number( image.flg_shared ) < 1" class="text-center">
                            <b-button
                                size="sm"
                                class="mt-2"
                                variant="yokumiru-blue"
                                @click="updateFlgShared(image.id, 1)">
                                {{ $locale.patient }}へ共有
                            </b-button>
                        </div>
                        <div v-else class="text-center">
                            <b-button
                                size="sm"
                                class="mt-2"
                                variant="yokumiru-gray"
                                @click="updateFlgShared(image.id, 0)">
                                共有をやめる
                            </b-button>
                        </div>
                        <div class="text-center">
                            <b-button
                                size="sm"
                                class="mt-2 ml-2"
                                variant="yokumiru-gray"
                                :href="image.presigned_url"
                                target="_blank"
                                @click="validateUrlExpired(image.presigned_url, $event)">
                                DL
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!!editable"
                class="d-flex justify-content-between align-items-center mt-3">
                <div class="input-group input-attach-wrapper mr-3">
                    <b-form-file
                        v-model="file"
                        ref="fileinput"
                        accept="image/jpeg, image/png, image/gif, application/pdf"
                        placeholder="画像（jpg, png, gif）またはPDFをアップロード"
                        @change="bindSelectedImage"
                        style="max-width: 350px;"
                        :class="{ 'is-invalid' : errors.file }">
                    </b-form-file>
                    <div class="ml-3">
                        <div v-if="uploadImage.base64 !== null">
                            <img class="uploadImage" :src="uploadImage.base64">
                        </div>
                    </div>
                    <div class="invalid-feedback d-block mt-1"
                         v-if="errors.file">
                        {{ errors.file[0] }}
                    </div>
                </div>
                <button
                    v-if="!!editable"
                    :disabled="file === null"
                    @click="attach"
                    class="btn btn-yokumiru-orange float-right vc-send-button">
                    添付
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from "moment-timezone"

    export default {
        props: {
            data: {
                type: Object,
                default: null,
            },
            consultationId: {
                type: Number,
                default: null,
            },
            isOnlyContent: {
                type: Boolean,
                default: false,
            },
            editable: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                inProgress: false,
                isShow: true,
                images: null,
                file: null,
                errors: {},
                uploadImage: {
                    name: null,
                    object: null,
                    base64: null,
                },
                componentCreatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            };
        },

        created: function() {
            if ( this.consultationId ) {
                this.fetchImages()
            }
            else {
                this.images = this.data
                this.isShow = this.images && this.images.length > 0
                bus.$emit('update-tab-css', 'attached_image', this.isShow)
            }
        },

        mounted: function () {
            window.Echo.private(`consultation.${this.consultationId}`)
                .listen('ConsultationAttachmentShared', () => {
                    this.fetchImages()
                })

            this.initImage()
        },

        methods: {
            /**
             * 添付画像一覧
             */
            fetchImages: function () {
                axios.get(`${constants.doctor.consultations.endpoint.base}/${this.consultationId}/attached_images`)
                    .then(({data}) => {
                        this.images = data
                        this.isShow = this.images && this.images.length > 0
                        bus.$emit('update-tab-css', 'attached_image', this.isShow)
                    })
            },

            /**
             * 共有設定の更新
             *
             * @param {number} id
             * @param {number} flg
             */
            updateFlgShared: function (id, flg) {
                const data = { flg_shared: flg }

                axios.put(`${constants.doctor.consultations.endpoint.attachedImages}/${id}`, data)
                    .then(() => {
                        const idx = this.images.findIndex((image) => {
                            return Number(image.id) === Number(id)
                        })
                        this.images[idx].flg_shared = flg
                    })
            },

            /**
             * ファイル添付
             */
            attach: async function () {
                if (this.inProgress) return
                this.inProgress = true

                if (this.file === null) {
                    return
                }

                const req = this.prepareRequest()
                const endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultationId}/attached_images`

                await axios.post(endpoint, req.formData, req.config)
                    .then(({data}) => {
                        this.images = data
                        this.errors = {}
                         // 画像添付後、必ずisShowをtrueに設定
                        this.isShow = true
                        // タブCSSも更新
                        bus.$emit('update-tab-css', 'attached_image', true)
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                        }
                    })

                // 添付エリアリセット
                this.$refs.fileinput.reset()
                this.initImage()

                this.inProgress = false
            },

            /**
             * ファイル添付リクエスト準備
             *
             * @return {Object}
             */
            prepareRequest: function() {
                let formData = new FormData()
                formData.append('file', this.file)

                return {
                    formData: formData,
                    config: {
                        headers: { 'content-type': 'multipart/form-data' },
                    },
                }
            },

            openModal: function(ref){
                bus.$emit('open-modal-image', ref)
            },

            /**
             * 画像選択時処理
             *
             * @return {void}
             */
            bindSelectedImage: function(e) {
                const elem = e.target
                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10485760) {
                        this.errors = { file: ['ファイルサイズは10MB以内にしてください。'] }
                        setTimeout(() => this.initImage(), 100)
                        return
                    }

                    if (elem.files[0].type !== 'application/pdf') {
                        this.uploadImage.object = elem.files[0]
                        this.uploadImage.name = this.uploadImage.object.name

                        const fr = new FileReader()
                        fr.onload = () => { this.uploadImage.base64 = fr.result }
                        fr.readAsDataURL(this.uploadImage.object)
                    }
                } else {
                    this.initImage()
                }
            },

            /**
             * 状態初期化
             */
            initImage: function() {
                this.file = null
                this.uploadImage = {
                    name: null,
                    object: null,
                    base64: null,
                }
            },

            /**
             * DLリンクの有効期限バリデーション
             *
             * @param {string} url
             * @param {object} event
             */
            validateUrlExpired: function (url, event) {
                const expiredSec = Number(url.replace(/^.+X-Amz-Expires=([0-9]+).+$/u, '$1'))
                const expiredAt = moment(this.componentCreatedAt).add(expiredSec, 'seconds')
                const expired = moment().isSameOrAfter(expiredAt)

                if (expired) {
                    bus.$emit('alert-warning', 'ダウンロードの有効期限が切れています。ブラウザを再読み込みしてください。')
                    event.preventDefault()
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .vc-send-button {
        width: 80px;
    }

    .isOnlyContentWrapper {
        padding: 0 15px;
        box-sizing: border-box;
    }

    .attachedPdf {
        width: 100px !important;
    }

    .attachedPdfFlgShared {
        right: 42px !important;
    }
</style>

<style lang="scss">
    .is-invalid {
        .custom-file-label {
            border: 1px solid #dc3545;
        }
    }

    .uploadImage {
        width: 100px;
    }

    div.input-attach-wrapper {
        max-width: 380px;

        span.form-file-text {
            color: #495057;
            font-size: 0.75rem;
            line-height: 24px;
        }
    }
</style>
